
  import { Vue } from 'vue-class-component';
  import { useRouter, useRoute } from 'vue-router'
  import { QA } from "./qa/qa";
  import { sanitizeHtml } from "../service/html-sanitizer";

  export default class QADetailView extends Vue {
    sanitizeHtml = sanitizeHtml
    router = useRouter()
    route = useRoute()

    id: string = this.route.params.id as string
    item = QA.getData(parseInt(this.id))
  }
